import { AppLink } from '@common/components/Link/AppLink';
import { SearchBar } from '@common/components/SearchBar';
import { Layout } from '@common/layouts';
import { Box, Flex, ScrollArea, Text } from '@radix-ui/themes';
import { AdvancedSearchPagePath } from '@router/constants';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { HomeUI } from './HomeUI';

import styles from './Home.module.css';

export const HomePage = () => {
    const { t } = useTranslation('home');
    const navigate = useNavigate();

    const handleSearchSubmit = (searchTerm: string) => {
        const trimmed = searchTerm.trim();
        if (trimmed) {
            const params = new URLSearchParams();
            params.set('search', trimmed);
            navigate(`${AdvancedSearchPagePath}?${params.toString()}`);
        }
    };

    return (
        <Layout.Content p={'2'} overflow={'hidden'}>
            <ScrollArea type='scroll' className={styles.scrollArea}>
                <Flex direction={'column'} width={'100%'}>
                    <Box my={'1'} width={'550px'} height={'45px'} asChild>
                        <SearchBar
                            size={'3'}
                            name={'AdvancedSearch'}
                            placeholder={t('search.placeholder')}
                            onSubmit={handleSearchSubmit}
                        />
                    </Box>

                    <Box p={'1'} px={'3'} mb={'4'}>
                        <Text
                            color='gray'
                            size={'2'}
                            weight={'regular'}
                            asChild
                        >
                            <AppLink to={AdvancedSearchPagePath}>
                                <Trans i18nKey={'pages.advanced_search'} />
                            </AppLink>
                        </Text>
                    </Box>
                </Flex>

                <Flex flexGrow={'1'}>
                    <HomeUI />
                </Flex>
            </ScrollArea>
        </Layout.Content>
    );
};
